import { PropsWithChildren } from 'react'

export const FragmentStyleContainer = ({ children }: PropsWithChildren) => {
  return <div className="font-sans">{children}</div>
}
